export interface VerbFlashcard {
  id: string;
  type: "verb";
  category: string;
  verb: string;
  tense: string;
  front: string;
  prompts: string[];
  answers: {
    je: string;
    tu: string;
    ilElleOn: string;
    nous: string;
    vous: string;
    ilsElles: string;
  };
  back: string;
  example: string;
  tags: string[];
}

export const frenchVerbFlashcards: VerbFlashcard[] = [
  // --- PRÉSENT ---
  {
    id: "verb-etre-present",
    type: "verb",
    category: "Verbes essentiels",
    verb: "être",
    tense: "Présent",
    front: "Conjuguez le verbe « être » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "suis",
      tu: "es",
      ilElleOn: "est",
      nous: "sommes",
      vous: "êtes",
      ilsElles: "sont"
    },
    back: "je suis\ntu es\nil/elle/on est\nnous sommes\nvous êtes\nils/elles sont",
    example: "Je suis prêt pour l'examen du TEF.",
    tags: ["verbe", "présent", "essentiel"]
  },
  {
    id: "verb-avoir-present",
    type: "verb",
    category: "Verbes essentiels",
    verb: "avoir",
    tense: "Présent",
    front: "Conjuguez le verbe « avoir » au présent.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai",
      tu: "as",
      ilElleOn: "a",
      nous: "avons",
      vous: "avez",
      ilsElles: "ont"
    },
    back: "j'ai\ntu as\nil/elle/on a\nnous avons\nvous avez\nils/elles ont",
    example: "Nous avons d'excellentes opportunités au Canada.",
    tags: ["verbe", "présent", "essentiel"]
  },
  {
    id: "verb-aller-present",
    type: "verb",
    category: "Verbes essentiels",
    verb: "aller",
    tense: "Présent",
    front: "Conjuguez le verbe « aller » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "vais",
      tu: "vas",
      ilElleOn: "va",
      nous: "allons",
      vous: "allez",
      ilsElles: "vont"
    },
    back: "je vais\ntu vas\nil/elle/on va\nnous allons\nvous allez\nils/elles vont",
    example: "Je vais déménager à Montréal l'année prochaine.",
    tags: ["verbe", "présent", "essentiel"]
  },
  {
    id: "verb-faire-present",
    type: "verb",
    category: "Verbes essentiels",
    verb: "faire",
    tense: "Présent",
    front: "Conjuguez le verbe « faire » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "fais",
      tu: "fais",
      ilElleOn: "fait",
      nous: "faisons",
      vous: "faites",
      ilsElles: "font"
    },
    back: "je fais\ntu fais\nil/elle/on fait\nnous faisons\nvous faites\nils/elles font",
    example: "Vous faites de grands progrès en français.",
    tags: ["verbe", "présent", "essentiel"]
  },
  {
    id: "verb-pouvoir-present",
    type: "verb",
    category: "Verbes modaux",
    verb: "pouvoir",
    tense: "Présent",
    front: "Conjuguez le verbe « pouvoir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "peux",
      tu: "peux",
      ilElleOn: "peut",
      nous: "puvons",
      vous: "pouvez",
      ilsElles: "peuvent"
    },
    back: "je peux\ntu peux\nil/elle/on peut\nnous pouvons\nvous pouvez\nils/elles peuvent",
    example: "Vous pouvez réussir cet examen avec de la pratique.",
    tags: ["verbe", "présent", "modal"]
  },
  {
    id: "verb-vouloir-present",
    type: "verb",
    category: "Verbes modaux",
    verb: "vouloir",
    tense: "Présent",
    front: "Conjuguez le verbe « vouloir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "veux",
      tu: "veux",
      ilElleOn: "veut",
      nous: "voulons",
      vous: "voulez",
      ilsElles: "veulent"
    },
    back: "je veux\ntu veux\nil/elle/on veut\nnous voulons\nvous voulez\nils/elles veulent",
    example: "Je veux obtenir le niveau C1 au TEF Canada.",
    tags: ["verbe", "présent", "modal"]
  },
  {
    id: "verb-devoir-present",
    type: "verb",
    category: "Verbes modaux",
    verb: "devoir",
    tense: "Présent",
    front: "Conjuguez le verbe « devoir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "dois",
      tu: "dois",
      ilElleOn: "doit",
      nous: "devons",
      vous: "devez",
      ilsElles: "doivent"
    },
    back: "je dois\ntu dois\nil/elle/on doit\nnous devons\nvous devez\nils/elles doivent",
    example: "Nous devons respecter les délais imposés.",
    tags: ["verbe", "présent", "modal"]
  },
  {
    id: "verb-savoir-present",
    type: "verb",
    category: "Verbes essentiels",
    verb: "savoir",
    tense: "Présent",
    front: "Conjuguez le verbe « savoir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "sais",
      tu: "sais",
      ilElleOn: "sait",
      nous: "savons",
      vous: "savez",
      ilsElles: "savent"
    },
    back: "je sais\ntu sais\nil/elle/on sait\nnous savons\nvous savez\nils/elles savent",
    example: "Elle sait parler couramment trois langues.",
    tags: ["verbe", "présent", "essentiel"]
  },
  {
    id: "verb-venir-present",
    type: "verb",
    category: "Verbes de mouvement",
    verb: "venir",
    tense: "Présent",
    front: "Conjuguez le verbe « venir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "viens",
      tu: "viens",
      ilElleOn: "vient",
      nous: "venons",
      vous: "venez",
      ilsElles: "viennent"
    },
    back: "je viens\ntu viens\nil/elle/on vient\nnous venons\nvous venez\nils/elles viennent",
    example: "Ils viennent d'arriver à l'aéroport de Vancouver.",
    tags: ["verbe", "présent", "mouvement"]
  },
  {
    id: "verb-prendre-present",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "prendre",
    tense: "Présent",
    front: "Conjuguez le verbe « prendre » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "prends",
      tu: "prends",
      ilElleOn: "prend",
      nous: "prenons",
      vous: "prenez",
      ilsElles: "prennent"
    },
    back: "je prends\ntu prends\nil/elle/on prend\nnous prenons\nvous prenez\nils/elles prennent",
    example: "Je prends des cours intensifs chaque matin.",
    tags: ["verbe", "présent", "groupe3"]
  },
  {
    id: "verb-mettre-present",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "mettre",
    tense: "Présent",
    front: "Conjuguez le verbe « mettre » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "mets",
      tu: "mets",
      ilElleOn: "met",
      nous: "mettons",
      vous: "mettez",
      ilsElles: "mettent"
    },
    back: "je mets\ntu mets\nil/elle/on met\nnous mettons\nvous mettez\nils/elles mettent",
    example: "Il met beaucoup d'énergie dans son projet d'immigration.",
    tags: ["verbe", "présent", "groupe3"]
  },
  {
    id: "verb-dire-present",
    type: "verb",
    category: "Verbes de communication",
    verb: "dire",
    tense: "Présent",
    front: "Conjuguez le verbe « dire » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "dis",
      tu: "dis",
      ilElleOn: "dit",
      nous: "disons",
      vous: "dites",
      ilsElles: "disent"
    },
    back: "je dis\ntu dis\nil/elle/on dit\nnous disons\nvous dites\nils/elles disent",
    example: "Que dites-vous de cette nouvelle politique ?",
    tags: ["verbe", "présent", "communication"]
  },
  {
    id: "verb-voir-present",
    type: "verb",
    category: "Verbes de perception",
    verb: "voir",
    tense: "Présent",
    front: "Conjuguez le verbe « voir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "vois",
      tu: "vois",
      ilElleOn: "voit",
      nous: "voyons",
      vous: "voyez",
      ilsElles: "voient"
    },
    back: "je vois\ntu vois\nil/elle/on voit\nnous voyons\nvous voyez\nils/elles voient",
    example: "Nous voyons clairement les avantages de ce programme.",
    tags: ["verbe", "présent", "perception"]
  },
  {
    id: "verb-donner-present",
    type: "verb",
    category: "Verbes du 1er groupe",
    verb: "donner",
    tense: "Présent",
    front: "Conjuguez le verbe « donner » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "donne",
      tu: "donnes",
      ilElleOn: "donne",
      nous: "donnons",
      vous: "donnez",
      ilsElles: "donnent"
    },
    back: "je donne\ntu donnes\nil/elle/on donne\nnous donnons\nvous donnez\nils/elles donnent",
    example: "Ce certificat donne accès à la résidence permanente.",
    tags: ["verbe", "présent", "groupe1"]
  },
  {
    id: "verb-parler-present",
    type: "verb",
    category: "Verbes de communication",
    verb: "parler",
    tense: "Présent",
    front: "Conjuguez le verbe « parler » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "parle",
      tu: "parles",
      ilElleOn: "parle",
      nous: "parlons",
      vous: "parlez",
      ilsElles: "parlent"
    },
    back: "je parle\ntu parles\nil/elle/on parle\nnous parlons\nvous parlez\nils/elles parlent",
    example: "Je parle français avec mes collègues québécois.",
    tags: ["verbe", "présent", "groupe1"]
  },
  {
    id: "verb-finir-present",
    type: "verb",
    category: "Verbes du 2e groupe",
    verb: "finir",
    tense: "Présent",
    front: "Conjuguez le verbe « finir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "finis",
      tu: "finis",
      ilElleOn: "finit",
      nous: "finissons",
      vous: "finissez",
      ilsElles: "finissent"
    },
    back: "je finis\ntu finis\nil/elle/on finit\nnous finissons\nvous finissez\nils/elles finissent",
    example: "Nous finissons notre préparation ce soir.",
    tags: ["verbe", "présent", "groupe2"]
  },
  {
    id: "verb-choisir-present",
    type: "verb",
    category: "Verbes du 2e groupe",
    verb: "choisir",
    tense: "Présent",
    front: "Conjuguez le verbe « choisir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "choisis",
      tu: "choisis",
      ilElleOn: "choisit",
      nous: "choisissons",
      vous: "choisissez",
      ilsElles: "choisissent"
    },
    back: "je choisis\ntu choisis\nil/elle/on choisit\nnous choisissons\nvous choisissez\nils/elles choisissent",
    example: "Les candidats choisissent souvent la province de l'Ontario.",
    tags: ["verbe", "présent", "groupe2"]
  },
  {
    id: "verb-comprendre-present",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "comprendre",
    tense: "Présent",
    front: "Conjuguez le verbe « comprendre » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "comprends",
      tu: "comprends",
      ilElleOn: "comprend",
      nous: "comprenons",
      vous: "comprenez",
      ilsElles: "comprennent"
    },
    back: "je comprends\ntu comprends\nil/elle/on comprend\nnous comprenons\nvous comprenez\nils/elles comprennent",
    example: "Je comprends l'importance de chaque épreuve.",
    tags: ["verbe", "présent", "groupe3"]
  },
  {
    id: "verb-ecrire-present",
    type: "verb",
    category: "Verbes de communication",
    verb: "écrire",
    tense: "Présent",
    front: "Conjuguez le verbe « écrire » au présent.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "écris",
      tu: "écris",
      ilElleOn: "écrit",
      nous: "écrivons",
      vous: "écrivez",
      ilsElles: "écrivent"
    },
    back: "j'écris\ntu écris\nil/elle/on écrit\nnous écrivons\nvous écrivez\nils/elles écrivent",
    example: "J'écris une lettre formelle pour le fait divers.",
    tags: ["verbe", "présent", "communication"]
  },
  {
    id: "verb-lire-present",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "lire",
    tense: "Présent",
    front: "Conjuguez le verbe « lire » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "lis",
      tu: "lis",
      ilElleOn: "lit",
      nous: "lisons",
      vous: "lisez",
      ilsElles: "lisent"
    },
    back: "je lis\ntu lis\nil/elle/on lit\nnous lisons\nvous lisez\nils/elles lisent",
    example: "Vous lisez des articles de presse pour améliorer votre vocabulaire.",
    tags: ["verbe", "présent", "groupe3"]
  },
  {
    id: "verb-connaitre-present",
    type: "verb",
    category: "Verbes de conhecimento",
    verb: "connaître",
    tense: "Présent",
    front: "Conjuguez le verbe « connaître » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "connais",
      tu: "connais",
      ilElleOn: "connaît",
      nous: "connaissons",
      vous: "connaissez",
      ilsElles: "connaissent"
    },
    back: "je connais\ntu connais\nil/elle/on connaît\nnous connaissons\nvous connaissez\nils/elles connaissent",
    example: "Je connais bien les critères d'évaluation du TEF.",
    tags: ["verbe", "présent", "groupe3"]
  },
  {
    id: "verb-croire-present",
    type: "verb",
    category: "Verbes de pensée",
    verb: "croire",
    tense: "Présent",
    front: "Conjuguez le verbe « croire » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "crois",
      tu: "crois",
      ilElleOn: "croit",
      nous: "croyons",
      vous: "croyez",
      ilsElles: "croient"
    },
    back: "je crois\ntu crois\nil/elle/on croit\nnous croyons\nvous croyez\nils/elles croient",
    example: "Je crois que cette méthode est la plus efficace.",
    tags: ["verbe", "présent", "pensee"]
  },
  {
    id: "verb-penser-present",
    type: "verb",
    category: "Verbes de pensamento",
    verb: "penser",
    tense: "Présent",
    front: "Conjuguez le verbe « penser » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "pense",
      tu: "penses",
      ilElleOn: "pense",
      nous: "pensons",
      vous: "pensez",
      ilsElles: "pensent"
    },
    back: "je pense\ntu penses\nil/elle/on pense\nnous pensons\nvous pensez\nils/elles pensent",
    example: "Nous pensons déménager au Québec dès que possible.",
    tags: ["verbe", "présent", "pensee"]
  },
  {
    id: "verb-demander-present",
    type: "verb",
    category: "Verbes de comunicação",
    verb: "demander",
    tense: "Présent",
    front: "Conjuguez le verbe « demander » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "demande",
      tu: "demandes",
      ilElleOn: "demande",
      nous: "demandons",
      vous: "demandez",
      ilsElles: "demandent"
    },
    back: "je demande\ntu demandes\nil/elle/on demande\nnous demandons\nvous demandez\nils/elles demandent",
    example: "L'examinateur demande de justifier votre point de vue.",
    tags: ["verbe", "présent", "communication"]
  },
  {
    id: "verb-trouver-present",
    type: "verb",
    category: "Verbes du 1er groupe",
    verb: "trouver",
    tense: "Présent",
    front: "Conjuguez le verbe « trouver » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "trouve",
      tu: "trouves",
      ilElleOn: "trouve",
      nous: "trouvons",
      vous: "trouvez",
      ilsElles: "trouvent"
    },
    back: "je trouve\ntu trouves\nil/elle/on trouve\nnous trouvons\nvous trouvez\nils/elles trouvent",
    example: "Je trouve cet exercice très pertinent.",
    tags: ["verbe", "présent", "groupe1"]
  },
  {
    id: "verb-travailler-present",
    type: "verb",
    category: "Verbes du 1er groupe",
    verb: "travailler",
    tense: "Présent",
    front: "Conjuguez le verbe « travailler » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "travaille",
      tu: "travailles",
      ilElleOn: "travaille",
      nous: "travaillons",
      vous: "travaillez",
      ilsElles: "travaillent"
    },
    back: "je travaille\ntu travailles\nil/elle/on travaille\nnous travaillons\nvous travaillez\nils/elles travaillent",
    example: "Elle travaille dans un environnement bilingue.",
    tags: ["verbe", "présent", "groupe1"]
  },
  {
    id: "verb-attendre-present",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "attendre",
    tense: "Présent",
    front: "Conjuguez le verbe « attendre » au présent.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "attends",
      tu: "attends",
      ilElleOn: "attend",
      nous: "attendons",
      vous: "attendez",
      ilsElles: "attendent"
    },
    back: "j'attends\ntu attends\nil/elle/on attend\nnous attendons\nvous attendez\nils/elles attendent",
    example: "Nous attendons les résultats avec impatience.",
    tags: ["verbe", "présent", "groupe3"]
  },
  {
    id: "verb-repondre-present",
    type: "verb",
    category: "Verbes de comunicação",
    verb: "répondre",
    tense: "Présent",
    front: "Conjuguez le verbe « répondre » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "réponds",
      tu: "réponds",
      ilElleOn: "répond",
      nous: "répondons",
      vous: "répondez",
      ilsElles: "répondent"
    },
    back: "je réponds\ntu réponds\nil/elle/on répond\nnous répondons\nvous répondez\nils/elles répondent",
    example: "Il est important de répondre précisément à la consigne.",
    tags: ["verbe", "présent", "communication"]
  },
  {
    id: "verb-recevoir-present",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "recevoir",
    tense: "Présent",
    front: "Conjuguez le verbe « recevoir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "reçois",
      tu: "reçois",
      ilElleOn: "reçoit",
      nous: "recevons",
      vous: "recevez",
      ilsElles: "reçoivent"
    },
    back: "je reçois\ntu reçois\nil/elle/on reçoit\nnous recevons\nvous recevez\nils/elles reçoivent",
    example: "Vous recevez une invitation officielle par courriel.",
    tags: ["verbe", "présent", "groupe3"]
  },
  {
    id: "verb-partir-present",
    type: "verb",
    category: "Verbes de mouvement",
    verb: "partir",
    tense: "Présent",
    front: "Conjuguez le verbe « partir » au présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "pars",
      tu: "pars",
      ilElleOn: "part",
      nous: "partons",
      vous: "partez",
      ilsElles: "partent"
    },
    back: "je pars\ntu pars\nil/elle/on part\nnous partons\nvous partez\nils/elles partent",
    example: "Ils partent vivre au Nouveau-Brunswick.",
    tags: ["verbe", "présent", "mouvement"]
  },

  // --- PASSÉ COMPOSÉ ---
  {
    id: "verb-etre-passe",
    type: "verb",
    category: "Verbes essenciais",
    verb: "être",
    tense: "Passé composé",
    front: "Conjuguez le verbe « être » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai été",
      tu: "as été",
      ilElleOn: "a été",
      nous: "avons été",
      vous: "avez été",
      ilsElles: "ont été"
    },
    back: "j'ai été\ntu as été\nil/elle/on a été\nnous avons été\nvous avez été\nils/elles ont été",
    example: "J'ai été agréablement surpris par l'accueil.",
    tags: ["verbe", "passe_compose", "essentiel"]
  },
  {
    id: "verb-avoir-passe",
    type: "verb",
    category: "Verbes essenciais",
    verb: "avoir",
    tense: "Passé composé",
    front: "Conjuguez le verbe « avoir » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai eu",
      tu: "as eu",
      ilElleOn: "a eu",
      nous: "avons eu",
      vous: "avez eu",
      ilsElles: "ont eu"
    },
    back: "j'ai eu\ntu as eu\nil/elle/on a eu\nnous avons eu\nvous avez eu\nils/elles ont eu",
    example: "Nous avons eu l'occasion de visiter Ottawa.",
    tags: ["verbe", "passe_compose", "essentiel"]
  },
  {
    id: "verb-aller-passe",
    type: "verb",
    category: "Verbes essenciais",
    verb: "aller",
    tense: "Passé composé",
    front: "Conjuguez le verbe « aller » au passé composé.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "suis allé",
      tu: "es allé",
      ilElleOn: "est allé",
      nous: "sommes allés",
      vous: "êtes allés",
      ilsElles: "sont allés"
    },
    back: "je suis allé(e)\ntu es allé(e)\nil/elle/on est allé(e)\nnous sommes allé(e)s\nvous êtes allé(e)(s)\nils/elles sont allé(e)s",
    example: "Elle est allée s'inscrire à l'université Laval.",
    tags: ["verbe", "passe_compose", "essentiel"]
  },
  {
    id: "verb-faire-passe",
    type: "verb",
    category: "Verbes essenciais",
    verb: "faire",
    tense: "Passé composé",
    front: "Conjuguez le verbe « faire » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai fait",
      tu: "as fait",
      ilElleOn: "a fait",
      nous: "avons fait",
      vous: "avez fait",
      ilsElles: "ont fait"
    },
    back: "j'ai fait\ntu as fait\nil/elle/on a fait\nnous avons fait\nvous avez fait\nils/elles ont fait",
    example: "Il a fait les démarches nécessaires pour son visa.",
    tags: ["verbe", "passe_compose", "essentiel"]
  },
  {
    id: "verb-pouvoir-passe",
    type: "verb",
    category: "Verbes modais",
    verb: "pouvoir",
    tense: "Passé composé",
    front: "Conjuguez le verbe « pouvoir » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai pu",
      tu: "as pu",
      ilElleOn: "a pu",
      nous: "avons pu",
      vous: "avez pu",
      ilsElles: "ont pu"
    },
    back: "j'ai pu\ntu as pu\nil/elle/on a pu\nnous avons pu\nvous avez pu\nils/elles ont pu",
    example: "Heureusement, j'ai pu terminer l'épreuve à temps.",
    tags: ["verbe", "passe_compose", "modal"]
  },
  {
    id: "verb-vouloir-passe",
    type: "verb",
    category: "Verbes modais",
    verb: "vouloir",
    tense: "Passé composé",
    front: "Conjuguez le verbe « vouloir » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai voulu",
      tu: "as voulu",
      ilElleOn: "a voulu",
      nous: "avons voulu",
      vous: "avez voulu",
      ilsElles: "ont voulu"
    },
    back: "j'ai voulu\ntu as voulu\nil/elle/on a voulu\nnous avons voulu\nvous avez voulu\nils/elles ont voulu",
    example: "Ils ont voulu tenter leur chance dans le Grand Nord.",
    tags: ["verbe", "passe_compose", "modal"]
  },
  {
    id: "verb-devoir-passe",
    type: "verb",
    category: "Verbes modais",
    verb: "devoir",
    tense: "Passé composé",
    front: "Conjuguez le verbe « devoir » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai dû",
      tu: "as dû",
      ilElleOn: "a dû",
      nous: "avons dû",
      vous: "avez dû",
      ilsElles: "ont dû"
    },
    back: "j'ai dû\ntu as dû\nil/elle/on a dû\nnous avons dû\nvous avez dû\nils/elles ont dû",
    example: "Nous avons dû recommencer la procédure.",
    tags: ["verbe", "passe_compose", "modal"]
  },
  {
    id: "verb-savoir-passe",
    type: "verb",
    category: "Verbes essenciais",
    verb: "savoir",
    tense: "Passé composé",
    front: "Conjuguez le verbe « savoir » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai su",
      tu: "as su",
      ilElleOn: "a su",
      nous: "avons su",
      vous: "avez su",
      ilsElles: "ont su"
    },
    back: "j'ai su\ntu as su\nil/elle/on a su\nnous avons su\nvous avez su\nils/elles ont su",
    example: "Dès que j'ai su la nouvelle, j'ai réservé mon billet.",
    tags: ["verbe", "passe_compose", "essentiel"]
  },
  {
    id: "verb-venir-passe",
    type: "verb",
    category: "Verbes de movimento",
    verb: "venir",
    tense: "Passé composé",
    front: "Conjuguez le verbe « venir » au passé composé.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "suis venu",
      tu: "es venu",
      ilElleOn: "est venu",
      nous: "sommes venus",
      vous: "êtes venus",
      ilsElles: "sont venus"
    },
    back: "je suis venu(e)\ntu es venu(e)\nil/elle/on est venu(e)\nnous sommes venu(e)s\nvous êtes venu(e)(s)\nils/elles sont venu(e)s",
    example: "Mon ami est venu me soutenir pendant l'examen.",
    tags: ["verbe", "passe_compose", "mouvement"]
  },
  {
    id: "verb-prendre-passe",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "prendre",
    tense: "Passé composé",
    front: "Conjuguez le verbe « prendre » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai pris",
      tu: "as pris",
      ilElleOn: "a pris",
      nous: "avons pris",
      vous: "avez pris",
      ilsElles: "ont pris"
    },
    back: "j'ai pris\ntu as pris\nil/elle/on a pris\nnous avons pris\nvous avez pris\nils/elles ont pris",
    example: "Nous avons pris une decisão muito importante.",
    tags: ["verbe", "passe_compose", "groupe3"]
  },
  {
    id: "verb-mettre-passe",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "mettre",
    tense: "Passé composé",
    front: "Conjuguez le verbe « mettre » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai mis",
      tu: "as mis",
      ilElleOn: "a mis",
      nous: "avons mis",
      vous: "avez mis",
      ilsElles: "ont mis"
    },
    back: "j'ai mis\ntu as mis\nil/elle/on a mis\nnous avons mis\nvous avez mis\nils/elles ont mis",
    example: "J'ai mis tous mes documents dans le dossier.",
    tags: ["verbe", "passe_compose", "groupe3"]
  },
  {
    id: "verb-dire-passe",
    type: "verb",
    category: "Verbes de comunicação",
    verb: "dire",
    tense: "Passé composé",
    front: "Conjuguez le verbe « dire » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai dit",
      tu: "as dit",
      ilElleOn: "a dit",
      nous: "avons dit",
      vous: "avez dit",
      ilsElles: "ont dit"
    },
    back: "j'ai dit\ntu as dit\nil/elle/on a dit\nnous avons dit\nvous avez dit\nils/elles ont dit",
    example: "Elle a dit qu'elle souhaitait vivre en Ontario.",
    tags: ["verbe", "passe_compose", "communication"]
  },
  {
    id: "verb-comprendre-passe",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "comprendre",
    tense: "Passé composé",
    front: "Conjuguez le verbe « comprendre » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai compris",
      tu: "as compris",
      ilElleOn: "a compris",
      nous: "avons compris",
      vous: "avez compris",
      ilsElles: "ont compris"
    },
    back: "j'ai compris\ntu as compris\nil/elle/on a compris\nnous avons compris\nvous avez compris\nils/elles ont compris",
    example: "J'ai tout de suite compris la question posée.",
    tags: ["verbe", "passe_compose", "groupe3"]
  },
  {
    id: "verb-partir-passe",
    type: "verb",
    category: "Verbes de movimento",
    verb: "partir",
    tense: "Passé composé",
    front: "Conjuguez le verbe « partir » au passé composé.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "suis parti",
      tu: "es parti",
      ilElleOn: "est parti",
      nous: "sommes partis",
      vous: "êtes partis",
      ilsElles: "sont partis"
    },
    back: "je suis parti(e)\ntu es parti(e)\nil/elle/on est parti(e)\nnous sommes parti(e)s\nvous êtes parti(e)(s)\nils/elles sont parti(e)s",
    example: "Ils sont partis tôt ce matin pour l'ambassade.",
    tags: ["verbe", "passe_compose", "mouvement"]
  },
  {
    id: "verb-ecrire-passe",
    type: "verb",
    category: "Verbes de comunicação",
    verb: "écrire",
    tense: "Passé composé",
    front: "Conjuguez le verbe « écrire » au passé composé.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ai écrit",
      tu: "as écrit",
      ilElleOn: "a écrit",
      nous: "avons écrit",
      vous: "avez écrit",
      ilsElles: "ont écrit"
    },
    back: "j'ai écrit\ntu as écrit\nil/elle/on a écrit\nnous avons écrit\nvous avez écrit\nils/elles ont écrit",
    example: "J'ai écrit un article d'opinion convincente.",
    tags: ["verbe", "passe_compose", "communication"]
  },

  // --- IMPARFAIT ---
  {
    id: "verb-etre-imparfait",
    type: "verb",
    category: "Verbes essenciais",
    verb: "être",
    tense: "Imparfait",
    front: "Conjuguez le verbe « être » à l'imparfait.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "étais",
      tu: "étais",
      ilElleOn: "était",
      nous: "étions",
      vous: "étiez",
      ilsElles: "étaient"
    },
    back: "j'étais\ntu étais\nil/elle/on était\nnous étions\nvous étiez\nils/elles étaient",
    example: "Quand j'étais étudiant, je rêvais d'immigrer.",
    tags: ["verbe", "imparfait", "essentiel"]
  },
  {
    id: "verb-avoir-imparfait",
    type: "verb",
    category: "Verbes essenciais",
    verb: "avoir",
    tense: "Imparfait",
    front: "Conjuguez le verbe « avoir » à l'imparfait.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "avais",
      tu: "avais",
      ilElleOn: "avait",
      nous: "avions",
      vous: "aviez",
      ilsElles: "avaient"
    },
    back: "j'avais\ntu avais\nil/elle/on avait\nnous avions\nvous aviez\nils/elles avaient",
    example: "Nous avions beaucoup d'espoir concernant ce projet.",
    tags: ["verbe", "imparfait", "essentiel"]
  },
  {
    id: "verb-aller-imparfait",
    type: "verb",
    category: "Verbes essenciais",
    verb: "aller",
    tense: "Imparfait",
    front: "Conjuguez le verbe « aller » à l'imparfait.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "allais",
      tu: "allais",
      ilElleOn: "allait",
      nous: "allions",
      vous: "alliez",
      ilsElles: "allaient"
    },
    back: "j'allais\ntu allais\nil/elle/on allait\nnous allions\nvous alliez\nils/elles allaient",
    example: "J'allais souvent à la bibliothèque pour réviser.",
    tags: ["verbe", "imparfait", "essentiel"]
  },
  {
    id: "verb-faire-imparfait",
    type: "verb",
    category: "Verbes essenciais",
    verb: "faire",
    tense: "Imparfait",
    front: "Conjuguez le verbe « faire » à l'imparfait.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "faisais",
      tu: "faisais",
      ilElleOn: "faisait",
      nous: "faisions",
      vous: "faisiez",
      ilsElles: "faisaient"
    },
    back: "je faisais\ntu faisais\nil/elle/on faisait\nnous faisions\nvous faisiez\nils/elles faisaient",
    example: "Il faisait froid lors de notre arrivée au Québec.",
    tags: ["verbe", "imparfait", "essentiel"]
  },
  {
    id: "verb-pouvoir-imparfait",
    type: "verb",
    category: "Verbes modais",
    verb: "pouvoir",
    tense: "Imparfait",
    front: "Conjuguez le verbe « pouvoir » à l'imparfait.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "pouvais",
      tu: "pouvais",
      ilElleOn: "pouvait",
      nous: "pouvions",
      vous: "pouviez",
      ilsElles: "pouvaient"
    },
    back: "je pouvais\ntu pouvais\nil/elle/on pouvait\nnous pouvions\nvous pouviez\nils/elles pouvaient",
    example: "Avant, je ne pouvais pas tenir uma conversa fluida.",
    tags: ["verbe", "imparfait", "modal"]
  },
  {
    id: "verb-vouloir-imparfait",
    type: "verb",
    category: "Verbes modais",
    verb: "vouloir",
    tense: "Imparfait",
    front: "Conjuguez le verbe « vouloir » à l'imparfait.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "voulais",
      tu: "voulais",
      ilElleOn: "voulait",
      nous: "voulions",
      vous: "vouliez",
      ilsElles: "voulaient"
    },
    back: "je voulais\ntu voulais\nil/elle/on voulait\nnous voulions\nvous vouliez\nils/elles voulaient",
    example: "Elle voulait absolument découvrir la culture canadienne.",
    tags: ["verbe", "imparfait", "modal"]
  },
  {
    id: "verb-devoir-imparfait",
    type: "verb",
    category: "Verbes modais",
    verb: "devoir",
    tense: "Imparfait",
    front: "Conjuguez le verbe « devoir » à l'imparfait.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "devais",
      tu: "devais",
      ilElleOn: "devait",
      nous: "devions",
      vous: "deviez",
      ilsElles: "devaient"
    },
    back: "je devais\ntu devais\nil/elle/on devait\nnous devions\nvous deviez\nils/elles devaient",
    example: "Nous devions valider notre inscription avant midi.",
    tags: ["verbe", "imparfait", "modal"]
  },
  {
    id: "verb-savoir-imparfait",
    type: "verb",
    category: "Verbes essenciais",
    verb: "savoir",
    tense: "Imparfait",
    front: "Conjuguez le verbe « savoir » à l'imparfait.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "savais",
      tu: "savais",
      ilElleOn: "savait",
      nous: "savions",
      vous: "saviez",
      ilsElles: "savaient"
    },
    back: "je savais\ntu savais\nil/elle/on savait\nnous savions\nvous saviez\nils/elles savaient",
    example: "Je savais que cet effort porterait ses fruits.",
    tags: ["verbe", "imparfait", "essentiel"]
  },
  {
    id: "verb-prendre-imparfait",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "prendre",
    tense: "Imparfait",
    front: "Conjuguez le verbe « prendre » à l'imparfait.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "prenais",
      tu: "prenais",
      ilElleOn: "prenait",
      nous: "prenions",
      vous: "preniez",
      ilsElles: "prenaient"
    },
    back: "je prenais\ntu prenais\nil/elle/on prenait\nnous prenions\nvous preniez\nils/elles prenaient",
    example: "Je prenais des notes pendant chaque écoute.",
    tags: ["verbe", "imparfait", "groupe3"]
  },
  {
    id: "verb-voir-imparfait",
    type: "verb",
    category: "Verbes de percepção",
    verb: "voir",
    tense: "Imparfait",
    front: "Conjuguez le verbe « voir » à l'imparfait.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "voyais",
      tu: "voyais",
      ilElleOn: "voyait",
      nous: "voyions",
      vous: "voyiez",
      ilsElles: "voyaient"
    },
    back: "je voyais\ntu voyais\nil/elle/on voyait\nnous voyions\nvous voyiez\nils/elles voyaient",
    example: "Nous voyions déjà les progrès s'accumuler.",
    tags: ["verbe", "imparfait", "perception"]
  },

  // --- FUTUR SIMPLE ---
  {
    id: "verb-etre-futur",
    type: "verb",
    category: "Verbes essenciais",
    verb: "être",
    tense: "Futur simple",
    front: "Conjuguez le verbe « être » au futur simple.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "serai",
      tu: "seras",
      ilElleOn: "sera",
      nous: "serons",
      vous: "serez",
      ilsElles: "seront"
    },
    back: "je serai\ntu seras\nil/elle/on sera\nnous serons\nvous serez\nils/elles seront",
    example: "Je serai fier d'obtenir ma résidence.",
    tags: ["verbe", "futur", "essentiel"]
  },
  {
    id: "verb-avoir-futur",
    type: "verb",
    category: "Verbes essenciais",
    verb: "avoir",
    tense: "Futur simple",
    front: "Conjuguez le verbe « avoir » au futur simple.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "aurai",
      tu: "auras",
      ilElleOn: "aura",
      nous: "aurons",
      vous: "aurez",
      ilsElles: "auront"
    },
    back: "j'aurai\ntu auras\nil/elle/on aura\nnous aurons\nvous aurez\nils/elles auront",
    example: "Vous aurez de formidables opportunités de carrière.",
    tags: ["verbe", "futur", "essentiel"]
  },
  {
    id: "verb-aller-futur",
    type: "verb",
    category: "Verbes essenciais",
    verb: "aller",
    tense: "Futur simple",
    front: "Conjuguez le verbe « aller » au futur simple.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "irai",
      tu: "iras",
      ilElleOn: "ira",
      nous: "irons",
      vous: "irez",
      ilsElles: "iront"
    },
    back: "j'irai\ntu iras\nil/elle/on ira\nnous irons\nvous irez\nils/elles iront",
    example: "Nous irons vivre au Canada l'été prochain.",
    tags: ["verbe", "futur", "essentiel"]
  },
  {
    id: "verb-faire-futur",
    type: "verb",
    category: "Verbes essenciais",
    verb: "faire",
    tense: "Futur simple",
    front: "Conjuguez le verbe « faire » au futur simple.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ferai",
      tu: "feras",
      ilElleOn: "fera",
      nous: "ferons",
      vous: "ferez",
      ilsElles: "feront"
    },
    back: "je ferai\ntu feras\nil/elle/on fera\nnous ferons\nvous ferez\nils/elles feront",
    example: "Je ferai de mon mieux lors de l'expression orale.",
    tags: ["verbe", "futur", "essentiel"]
  },
  {
    id: "verb-pouvoir-futur",
    type: "verb",
    category: "Verbes modais",
    verb: "pouvoir",
    tense: "Futur simple",
    front: "Conjuguez le verbe « pouvoir » au futur simple.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "pourrai",
      tu: "pourras",
      ilElleOn: "pourra",
      nous: "pourrons",
      vous: "pourrez",
      ilsElles: "pourront"
    },
    back: "je pourrai\ntu pourras\nil/elle/on pourra\nnous pourrons\nvous pourrez\nils/elles pourront",
    example: "Vous pourrez voyager librement à travers le pays.",
    tags: ["verbe", "futur", "modal"]
  },
  {
    id: "verb-vouloir-futur",
    type: "verb",
    category: "Verbes modais",
    verb: "vouloir",
    tense: "Futur simple",
    front: "Conjuguez le verbe « vouloir » au futur simple.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "voudrai",
      tu: "voudras",
      ilElleOn: "voudra",
      nous: "voudrons",
      vous: "voudrez",
      ilsElles: "voudront"
    },
    back: "je voudrai\ntu voudras\nil/elle/on voudra\nnous voudrons\nvous voudrez\nils/elles voudront",
    example: "Il voudra certainement s'intégrer rapidement.",
    tags: ["verbe", "futur", "modal"]
  },
  {
    id: "verb-devoir-futur",
    type: "verb",
    category: "Verbes modais",
    verb: "devoir",
    tense: "Futur simple",
    front: "Conjuguez le verbe « devoir » au futur simple.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "devrai",
      tu: "devras",
      ilElleOn: "devra",
      nous: "devrons",
      vous: "devrez",
      ilsElles: "devront"
    },
    back: "je devrai\ntu devras\nil/elle/on devra\nnous devrons\nvous devrez\nils/elles devront",
    example: "Nous devrons envoyer la confirmation sous peu.",
    tags: ["verbe", "futur", "modal"]
  },
  {
    id: "verb-savoir-futur",
    type: "verb",
    category: "Verbes essenciais",
    verb: "savoir",
    tense: "Futur simple",
    front: "Conjuguez le verbe « savoir » au futur simple.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "saurai",
      tu: "sauras",
      ilElleOn: "saura",
      nous: "saurons",
      vous: "saurez",
      ilsElles: "sauront"
    },
    back: "je saurai\ntu sauras\nil/elle/on saura\nnous saurons\nvous saurez\nils/elles sauront",
    example: "Elle saura comment répondre aux questions complexes.",
    tags: ["verbe", "futur", "essentiel"]
  },
  {
    id: "verb-venir-futur",
    type: "verb",
    category: "Verbes de movimento",
    verb: "venir",
    tense: "Futur simple",
    front: "Conjuguez le verbe « venir » au futur simple.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "viendrai",
      tu: "viendras",
      ilElleOn: "viendra",
      nous: "viendrons",
      vous: "viendrez",
      ilsElles: "viendront"
    },
    back: "je viendrai\ntu viendras\nil/elle/on viendra\nnous viendrons\nvous viendrez\nils/elles viendront",
    example: "Ils viendront nous rendre visite à Toronto.",
    tags: ["verbe", "futur", "mouvement"]
  },
  {
    id: "verb-voir-futur",
    type: "verb",
    category: "Verbes de percepção",
    verb: "voir",
    tense: "Futur simple",
    front: "Conjuguez le verbe « voir » au futur simple.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "verrai",
      tu: "verras",
      ilElleOn: "verra",
      nous: "verrons",
      vous: "verrez",
      ilsElles: "verront"
    },
    back: "je verrai\ntu verras\nil/elle/on verra\nnous verrons\nvous verrez\nils/elles verront",
    example: "Nous verrons les resultados d'ici deux semaines.",
    tags: ["verbe", "futur", "perception"]
  },

  // --- CONDITIONNEL PRÉSENT ---
  {
    id: "verb-etre-conditionnel",
    type: "verb",
    category: "Verbes essenciais",
    verb: "être",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « être » au conditionnel présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "serais",
      tu: "serais",
      ilElleOn: "serait",
      nous: "serions",
      vous: "seriez",
      ilsElles: "seraient"
    },
    back: "je serais\ntu serais\nil/elle/on serait\nnous serions\nvous seriez\nils/elles seraient",
    example: "Ce serait une opportunité extraordinaire pour ma famille.",
    tags: ["verbe", "conditionnel", "essentiel"]
  },
  {
    id: "verb-avoir-conditionnel",
    type: "verb",
    category: "Verbes essenciais",
    verb: "avoir",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « avoir » au conditionnel présent.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "aurais",
      tu: "aurais",
      ilElleOn: "aurait",
      nous: "aurions",
      vous: "auriez",
      ilsElles: "auraient"
    },
    back: "j'aurais\ntu aurais\nil/elle/on aurait\nnous aurions\nvous auriez\nils/elles auraient",
    example: "J'aurais aimé commencer ma préparation plus tôt.",
    tags: ["verbe", "conditionnel", "essentiel"]
  },
  {
    id: "verb-aller-conditionnel",
    type: "verb",
    category: "Verbes essenciais",
    verb: "aller",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « aller » au conditionnel présent.",
    prompts: ["j'", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "irais",
      tu: "irais",
      ilElleOn: "irait",
      nous: "irions",
      vous: "iriez",
      ilsElles: "iraient"
    },
    back: "j'irais\ntu irais\nil/elle/on irait\nnous irions\nvous iriez\nils/elles iraient",
    example: "Si je réussis, j'irais m'installer en Colombie-Britannique.",
    tags: ["verbe", "conditionnel", "essentiel"]
  },
  {
    id: "verb-faire-conditionnel",
    type: "verb",
    category: "Verbes essenciais",
    verb: "faire",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « faire » au conditionnel présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "ferais",
      tu: "ferais",
      ilElleOn: "ferait",
      nous: "ferions",
      vous: "feriez",
      ilsElles: "feraient"
    },
    back: "je ferais\ntu ferais\nil/elle/on ferait\nnous ferions\nvous feriez\nils/elles feraient",
    example: "À votre place, je ferais plus d'exercices de grammaire.",
    tags: ["verbe", "conditionnel", "essentiel"]
  },
  {
    id: "verb-pouvoir-conditionnel",
    type: "verb",
    category: "Verbes modais",
    verb: "pouvoir",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « pouvoir » au conditionnel présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "pourrais",
      tu: "pourrais",
      ilElleOn: "pourrait",
      nous: "pourrions",
      vous: "pourriez",
      ilsElles: "pourraient"
    },
    back: "je pourrais\ntu pourrais\nil/elle/on pourrait\nnous pourrions\nvous pourriez\nils/elles pourraient",
    example: "Pourriez-vous m'expliquer la règle de l'accord du participe passé ?",
    tags: ["verbe", "conditionnel", "modal"]
  },
  {
    id: "verb-vouloir-conditionnel",
    type: "verb",
    category: "Verbes modais",
    verb: "vouloir",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « vouloir » au conditionnel présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "voudrais",
      tu: "voudrais",
      ilElleOn: "voudrait",
      nous: "voudrions",
      vous: "voudriez",
      ilsElles: "voudraient"
    },
    back: "je voudrais\ntu voudrais\nil/elle/on voudrait\nnous voudrions\nvous voudriez\nils/elles voudraient",
    example: "Je voudrais m'inscrire à la session d'examen du mois de juin.",
    tags: ["verbe", "conditionnel", "modal"]
  },
  {
    id: "verb-devoir-conditionnel",
    type: "verb",
    category: "Verbes modais",
    verb: "devoir",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « devoir » au conditionnel présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "devrais",
      tu: "devrais",
      ilElleOn: "devrait",
      nous: "devrions",
      vous: "devriez",
      ilsElles: "devraient"
    },
    back: "je devrais\ntu devrais\nil/elle/on devrait\nnous devrions\nvous devriez\nils/elles devraient",
    example: "Nous devrions relire notre texte avant de le remettre.",
    tags: ["verbe", "conditionnel", "modal"]
  },
  {
    id: "verb-savoir-conditionnel",
    type: "verb",
    category: "Verbes essenciais",
    verb: "savoir",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « savoir » au conditionnel présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "saurais",
      tu: "saurais",
      ilElleOn: "saurait",
      nous: "saurions",
      vous: "sauriez",
      ilsElles: "sauraient"
    },
    back: "je saurais\ntu saurais\nil/elle/on saurait\nnous saurions\nvous sauriez\nils/elles sauraient",
    example: "Elle saurait gérer la situation avec calme.",
    tags: ["verbe", "conditionnel", "essentiel"]
  },
  {
    id: "verb-venir-conditionnel",
    type: "verb",
    category: "Verbes de movimento",
    verb: "venir",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « venir » au conditionnel présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "viendrais",
      tu: "viendrais",
      ilElleOn: "viendrait",
      nous: "viendrions",
      vous: "viendriez",
      ilsElles: "viendraient"
    },
    back: "je viendrais\ntu viendrais\nil/elle/on viendrait\nnous viendrions\nvous viendriez\nils/elles viendraient",
    example: "Viendriez-vous assister à la séance d'information ?",
    tags: ["verbe", "conditionnel", "mouvement"]
  },
  {
    id: "verb-prendre-conditionnel",
    type: "verb",
    category: "Verbes du 3e groupe",
    verb: "prendre",
    tense: "Conditionnel présent",
    front: "Conjuguez le verbe « prendre » au conditionnel présent.",
    prompts: ["je", "tu", "il/elle/on", "nous", "vous", "ils/elles"],
    answers: {
      je: "prendrais",
      tu: "prendrais",
      ilElleOn: "prendrait",
      nous: "prendrions",
      vous: "prendriez",
      ilsElles: "prendraient"
    },
    back: "je prendrais\ntu prendrais\nil/elle/on prendrait\nnous prendrions\nvous prendriez\nils/elles prendraient",
    example: "Je prendrais bien un café en attendant le début du test.",
    tags: ["verbe", "conditionnel", "groupe3"]
  },

  // --- SUBJONCTIF PRÉSENT ---
  {
    id: "verb-etre-subjonctif",
    type: "verb",
    category: "Verbes essenciais",
    verb: "être",
    tense: "Subjonctif présent",
    front: "Conjuguez le verbe « être » au subjonctif présent.",
    prompts: ["que je", "que tu", "qu'il/elle/on", "que nous", "que vous", "qu'ils/elles"],
    answers: {
      je: "sois",
      tu: "sois",
      ilElleOn: "soit",
      nous: "soyons",
      vous: "soyez",
      ilsElles: "soient"
    },
    back: "que je sois\nque tu sois\nqu'il/elle/on soit\nque nous soyons\nque vous soyez\nqu'ils/elles soient",
    example: "Il est indispensable que je sois bien préparé.",
    tags: ["verbe", "subjonctif", "essentiel"]
  },
  {
    id: "verb-avoir-subjonctif",
    type: "verb",
    category: "Verbes essenciais",
    verb: "avoir",
    tense: "Subjonctif présent",
    front: "Conjuguez le verbe « avoir » au subjonctif présent.",
    prompts: ["que j'", "que tu", "qu'il/elle/on", "que nous", "que vous", "qu'ils/elles"],
    answers: {
      je: "aie",
      tu: "aies",
      ilElleOn: "ait",
      nous: "ayons",
      vous: "ayez",
      ilsElles: "aient"
    },
    back: "que j'aie\nque tu aies\nqu'il/elle/on ait\nque nous ayons\nque vous ayez\nqu'ils/elles aient",
    example: "Il faut que vous ayez tous vos papiers d'identité.",
    tags: ["verbe", "subjonctif", "essentiel"]
  },
  {
    id: "verb-aller-subjonctif",
    type: "verb",
    category: "Verbes essenciais",
    verb: "aller",
    tense: "Subjonctif présent",
    front: "Conjuguez le verbe « aller » au subjonctif présent.",
    prompts: ["que j'", "que tu", "qu'il/elle/on", "que nous", "que vous", "qu'ils/elles"],
    answers: {
      je: "aille",
      tu: "ailles",
      ilElleOn: "aille",
      nous: "allions",
      vous: "alliez",
      ilsElles: "aillent"
    },
    back: "que j'aille\nque tu ailles\nqu'il/elle/on aille\nque nous allions\nque vous alliez\nqu'ils/elles aillent",
    example: "Il est important que nous allions de l'avant.",
    tags: ["verbe", "subjonctif", "essentiel"]
  },
  {
    id: "verb-faire-subjonctif",
    type: "verb",
    category: "Verbes essenciais",
    verb: "faire",
    tense: "Subjonctif présent",
    front: "Conjuguez le verbe « faire » au subjonctif présent.",
    prompts: ["que je", "que tu", "qu'il/elle/on", "que nous", "que vous", "qu'ils/elles"],
    answers: {
      je: "fasse",
      tu: "fasses",
      ilElleOn: "fasse",
      nous: "fassions",
      vous: "fassiez",
      ilsElles: "fassent"
    },
    back: "que je fasse\nque tu fasses\nqu'il/elle/on fasse\nque nous fassions\nque vous fassiez\nqu'ils/elles fassent",
    example: "L'examinateur souhaite que je fasse une description détaillée.",
    tags: ["verbe", "subjonctif", "essentiel"]
  },
  {
    id: "verb-pouvoir-subjonctif",
    type: "verb",
    category: "Verbes modais",
    verb: "pouvoir",
    tense: "Subjonctif présent",
    front: "Conjuguez le verbe « pouvoir » au subjonctif présent.",
    prompts: ["que je", "que tu", "qu'il/elle/on", "que nous", "que vous", "qu'ils/elles"],
    answers: {
      je: "puisse",
      tu: "puisses",
      ilElleOn: "puisse",
      nous: "puissions",
      vous: "puissiez",
      ilsElles: "puissent"
    },
    back: "que je puisse\nque tu puisses\nqu'il/elle/on puisse\nque nous puissions\nque vous puissiez\nqu'ils/elles puissent",
    example: "Je m'exerce afin que je puisse m'exprimer sans hésitation.",
    tags: ["verbe", "subjonctif", "modal"]
  },
  {
    id: "verb-vouloir-subjonctif",
    type: "verb",
    category: "Verbes modais",
    verb: "vouloir",
    tense: "Subjonctif présent",
    front: "Conjuguez le verbe « vouloir » au subjonctif présent.",
    prompts: ["que je", "que tu", "qu'il/elle/on", "que nous", "que vous", "qu'ils/elles"],
    answers: {
      je: "veuille",
      tu: "veuilles",
      ilElleOn: "veuille",
      nous: "voulions",
      vous: "vouliez",
      ilsElles: "veuillent"
    },
    back: "que je veuille\nque tu veuilles\nqu'il/elle/on veuille\nque nous voulions\nque vous vouliez\nqu'ils/elles veuillent",
    example: "Bien qu'il veuille réussir, il doit étudier plus régulièrement.",
    tags: ["verbe", "subjonctif", "modal"]
  },
  {
    id: "verb-savoir-subjonctif",
    type: "verb",
    category: "Verbes essenciais",
    verb: "savoir",
    tense: "Subjonctif présent",
    front: "Conjuguez le verbe « savoir » au subjonctif présent.",
    prompts: ["que je", "que tu", "qu'il/elle/on", "que nous", "que vous", "qu'ils/elles"],
    answers: {
      je: "sache",
      tu: "saches",
      ilElleOn: "sache",
      nous: "sachions",
      vous: "sachiez",
      ilsElles: "sachent"
    },
    back: "que je sache\nque tu saches\nqu'il/elle/on sache\nque nous sachions\nque vous sachiez\nqu'ils/elles sachent",
    example: "Il est essentiel que vous sachiez conjuguer ces verbes.",
    tags: ["verbe", "subjonctif", "essentiel"]
  }
];
